$(function() {

	$('.close-notice-wrapper').on('click', function(event) {
		var id = $(this).data('id'),
			notices = getCookie('notices');

		if (!notices) notices = id;
		else {
			if (findInArray(notices.split(','), id) < 0) notices += "," + id;
		}

		setCookie('notices', notices, { 'expires' : 365, 'path' : '/'});
		$('.notice-wrapper').empty().remove();
	});

});